interface Props {
  children: React.ReactNode;
}

const Auth = ({ children }: Props) => {
  return (
    <section className="register">
      <div className="container-fluid">
        <div className="bg-white rounded-2">
          <div className="row g-0 justify-content-center">
            <div className="col-lg-6 d-flex justify-content-center align-items-center bg-register rounded-2">
              {/* <div className="py-3">
                <div className="text-center">
                  <h1>Welcome to</h1>
                  <p className="mb-0">Topvalue.com</p>
                  <img
                    src="/assets/images/topvalue-white-logo.png"
                    className="my-5"
                    alt=""
                  />
                  <p>
                    <b>คัดสรร นวัตกรรมสวยงาม...เพื่อคุณ</b>
                  </p>
                </div>
              </div> */}
            </div>
            <div className="col-lg-6 align-self-center">{children}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Auth;
